import React from 'react';

import classnames from 'classnames';

import LinkButton from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';

import { TP, PRODUCTION_LISTING_VIEW_TYPES } from 'constants/index';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import { useTranslation } from 'src/i18n';

import classes from './ProductionViewTypes.module.scss';

const ProductionViewTypes = ({ viewType, onViewTypeChange, trackingData = {} }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { isMobile } = useDeviceTypeLayouts();

  return (
    <div className={classes.viewTypeContainer}>
      <LinkButton
        variant="grey"
        styles={{
          root: classnames(classes.viewType, {
            [classes.viewType__active]: viewType === PRODUCTION_LISTING_VIEW_TYPES.PUBLIC_DAY_VIEW,
          }),
        }}
        size="medium"
        onClick={() => onViewTypeChange(PRODUCTION_LISTING_VIEW_TYPES.PUBLIC_DAY_VIEW)}
        leftIcon={<SpriteIcon icon={isMobile ? 'calendar' : 'list'} size={14} />}
        disableHover
        preventDefault
        stopPropagation
        trackingData={{
          ...trackingData,
          subComponent: SUB_COMPONENTS.PRODUCTION_VIEW_SWITCH,
        }}
      >
        {t(`${TP}.FN_DAY`)}
      </LinkButton>
      <LinkButton
        variant="grey"
        styles={{
          root: classnames(classes.viewType, {
            [classes.viewType__active]: viewType === PRODUCTION_LISTING_VIEW_TYPES.PUBLIC_SEASON_VIEW,
          }),
        }}
        size="medium"
        onClick={() => onViewTypeChange(PRODUCTION_LISTING_VIEW_TYPES.PUBLIC_SEASON_VIEW)}
        leftIcon={<SpriteIcon icon={isMobile ? 'list' : 'calendar'} size={14} />}
        disableHover
        preventDefault
        stopPropagation
        trackingData={{
          ...trackingData,
          subComponent: SUB_COMPONENTS.PRODUCTION_VIEW_SWITCH,
        }}
      >
        {t(`${TP}.FN_SEASON`)}
      </LinkButton>
      {!isMobile && (
        <LinkButton
          variant="grey"
          styles={{
            root: classnames(classes.viewType, {
              [classes.viewType__active]: isMobile
                ? viewType === PRODUCTION_LISTING_VIEW_TYPES.SEASON
                : viewType === PRODUCTION_LISTING_VIEW_TYPES.CALENDAR_VIEW,
            }),
          }}
          size="medium"
          onClick={() =>
            onViewTypeChange(
              isMobile ? PRODUCTION_LISTING_VIEW_TYPES.SEASON : PRODUCTION_LISTING_VIEW_TYPES.CALENDAR_VIEW,
            )
          }
          leftIcon={<SpriteIcon icon={isMobile ? 'list' : 'calendar'} size={14} />}
          disableHover
          preventDefault
          stopPropagation
          trackingData={{
            ...trackingData,
            subComponent: SUB_COMPONENTS.PRODUCTION_VIEW_SWITCH,
          }}
        >
          {t(`${TP}.FN_CALENDAR`)}
        </LinkButton>
      )}
    </div>
  );
};

export default ProductionViewTypes;
